import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Help() {
  const [openCategory, setOpenCategory] = useState(0);

  const helpCategories = [
    {
      title: 'Getting Started',
      icon: '🚀',
      questions: [
        {
          q: 'How does SlotsHub UK work?',
          a: 'SlotsHub UK is a comparison and review website that helps you find the best licensed UK online casinos. We evaluate casinos based on various criteria and provide honest recommendations. When you click through to a casino, you get the same bonuses and offers as going directly to the site.'
        },
        {
          q: 'Do I need to create an account on SlotsHub UK?',
          a: 'No, you don\'t need to create an account with us. Simply browse our reviews and recommendations, then sign up directly with any casino that interests you. We\'re here to help you compare options, not to hold your personal information.'
        },
        {
          q: 'Are the casinos you recommend safe?',
          a: 'Yes, every casino featured on SlotsHub UK holds a valid licence from the UK Gambling Commission (UKGC). This means they meet strict regulatory standards for player protection, fair gaming, responsible gambling tools, and secure transactions.'
        },
        {
          q: 'How do you make money?',
          a: 'We earn commission from casinos when players sign up through our links. This is standard practice for comparison websites and doesn\'t affect the bonuses you receive or our review scores. Our editorial process is independent from commercial relationships.'
        }
      ]
    },
    {
      title: 'Bonuses & Offers',
      icon: '🎁',
      questions: [
        {
          q: 'What are wagering requirements?',
          a: 'Wagering requirements (also called playthrough requirements) specify how many times you need to bet a bonus amount before you can withdraw any winnings. For example, a £10 bonus with 35x wagering means you need to place £350 worth of bets before withdrawal. Always check the specific terms at each casino.'
        },
        {
          q: 'Why do some bonuses say "no wagering"?',
          a: 'No wagering bonuses let you withdraw your winnings immediately without any playthrough requirements. These are considered the most player-friendly offers. Look for casinos like MrQ that specialise in no-wagering promotions.'
        },
        {
          q: 'Are the bonus amounts shown guaranteed?',
          a: 'The bonus information we display is accurate at the time of writing, but offers can change without notice. Always verify the current terms and conditions on the casino\'s website before signing up. We update our information regularly but casinos control their own promotions.'
        },
        {
          q: 'Can I claim multiple welcome bonuses?',
          a: 'Welcome bonuses are typically one per person, per household, per IP address. You can claim a welcome bonus at different casinos, but you cannot claim the same casino\'s welcome offer multiple times. Attempting to do so may result in account closure and forfeiture of funds.'
        }
      ]
    },
    {
      title: 'Payments & Withdrawals',
      icon: '💳',
      questions: [
        {
          q: 'What payment methods do UK casinos accept?',
          a: 'Most UK casinos accept debit cards (Visa, Mastercard), e-wallets (PayPal, Skrill, Neteller), bank transfers, and pay-by-mobile options. Note that credit cards are banned for gambling in the UK. Available methods vary by casino.'
        },
        {
          q: 'How long do withdrawals take?',
          a: 'Withdrawal times depend on the payment method. E-wallets typically process within 24 hours, debit cards take 1-3 business days, and bank transfers may take 3-5 business days. All casinos must process withdrawal requests within their stated timeframes as per UKGC regulations.'
        },
        {
          q: 'Why do casinos require verification?',
          a: 'UK casinos are legally required to verify your identity before allowing withdrawals. This includes proof of identity (passport, driving licence), proof of address (utility bill, bank statement), and sometimes proof of payment method. This prevents fraud, money laundering, and underage gambling.'
        },
        {
          q: 'Are there withdrawal limits?',
          a: 'Most casinos have minimum and maximum withdrawal limits. These vary by casino and payment method. High-value winnings may be paid in instalments. Always check the specific terms before playing, especially if you\'re hoping for a large jackpot win.'
        }
      ]
    },
    {
      title: 'Responsible Gambling',
      icon: '🛡️',
      questions: [
        {
          q: 'What responsible gambling tools are available?',
          a: 'UK-licensed casinos must offer deposit limits, loss limits, session time limits, cooling-off periods, and self-exclusion. You can set these in your account settings. Many casinos also offer reality checks that remind you how long you\'ve been playing.'
        },
        {
          q: 'What is GAMSTOP?',
          a: 'GAMSTOP is the UK\'s national self-exclusion scheme. When you register with GAMSTOP, you\'ll be excluded from all UKGC-licensed gambling websites for a chosen period (6 months, 1 year, or 5 years). It\'s free to use and can be done at https://www.gamstop.co.uk/.'
        },
        {
          q: 'Where can I get help for gambling problems?',
          a: 'Free, confidential support is available from GambleAware (https://www.gambleaware.org/), GamCare (https://www.gamcare.org.uk/, helpline: 0808 8020 133), and Gamblers Anonymous (https://www.gamblersanonymous.org.uk/). These organisations offer advice, counselling, and support for anyone affected by gambling.'
        },
        {
          q: 'How do I know if I have a gambling problem?',
          a: 'Warning signs include: spending more than you can afford, chasing losses, gambling to escape problems, lying about gambling, borrowing money to gamble, neglecting responsibilities, or feeling anxious when not gambling. If any of these apply, please seek help from the organisations listed above.'
        }
      ]
    },
    {
      title: 'Technical Issues',
      icon: '⚙️',
      questions: [
        {
          q: 'I\'m having trouble with a casino website. What should I do?',
          a: 'For technical issues with a specific casino, contact that casino\'s customer support directly – they\'ll be able to help with account access, game issues, or payment problems. SlotsHub UK cannot access your casino accounts or resolve issues on your behalf.'
        },
        {
          q: 'A casino hasn\'t paid me. Can you help?',
          a: 'We cannot intervene in disputes between players and casinos. First, contact the casino\'s customer support. If unresolved, you can escalate to the casino\'s licensed Alternative Dispute Resolution (ADR) provider, listed in their terms. The UKGC also has guidance on making complaints.'
        },
        {
          q: 'How do I report a problem with a casino?',
          a: 'If you believe a casino is operating unfairly or unlawfully, you can report them to the UK Gambling Commission at https://www.gamblingcommission.gov.uk/. Provide as much detail as possible including the casino name, licence number, and nature of your complaint.'
        }
      ]
    }
  ];

  return (
    <div className="page help-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <span className="page-badge">Help Centre</span>
            <h1>How Can We Help?</h1>
            <p>Find answers to common questions about casinos, bonuses, and safe gambling</p>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="help-categories">
            <div className="category-tabs">
              {helpCategories.map((category, index) => (
                <button
                  key={index}
                  className={`category-tab ${openCategory === index ? 'active' : ''}`}
                  onClick={() => setOpenCategory(index)}
                >
                  <span className="tab-icon">{category.icon}</span>
                  <span className="tab-title">{category.title}</span>
                </button>
              ))}
            </div>

            <div className="category-content">
              <h2>
                <span className="content-icon">{helpCategories[openCategory].icon}</span>
                {helpCategories[openCategory].title}
              </h2>
              <div className="faq-list">
                {helpCategories[openCategory].questions.map((item, index) => (
                  <div key={index} className="faq-item">
                    <h4 className="faq-question">{item.q}</h4>
                    <p className="faq-answer">{item.a}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="help-footer">
            <div className="help-card">
              <h3>Still Need Help?</h3>
              <p>Can't find the answer you're looking for? Our team is here to help.</p>
              <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            </div>
            <div className="help-card highlight">
              <h3>Gambling Support</h3>
              <p>If you need help with problem gambling, free support is available 24/7.</p>
              <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                GambleAware.org
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Help;
